import React from 'react';
import { connect } from 'react-redux';
import { Cell } from '@ff-os/shared-react/components/grid/Cell';
import { Grid } from '@ff-os/shared-react/components/grid/Grid';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectHasFontFamilyBold, selectHasFontFamilyItalic } from '../../_redux';
import { Bold } from './Bold';
import { Italic } from './Italic';

export const _FontStylingOptions = ({ variableIds, hasBold, hasItalic }: Props) => (
    <Grid gap='s'>
        {hasBold && (
            <Cell>
                <Bold variableIds={variableIds} />
            </Cell>
        )}
        {hasItalic && (
            <Cell>
                <Italic variableIds={variableIds} />
            </Cell>
        )}
    </Grid>
);

type Props = {
    variableIds: string[];
    hasBold: boolean;
    hasItalic: boolean;
};

const mapStateToProps = (state: GiftPdpState, ownProps: { variableIds: string[] }) => ({
    hasBold: selectHasFontFamilyBold(state, ownProps.variableIds[0]!),
    hasItalic: selectHasFontFamilyItalic(state, ownProps.variableIds[0]!)
});

export const FontStylingOptions = connect(
    mapStateToProps
)(_FontStylingOptions);